import { Instance } from 'mobx-state-tree';
import { DeleteCustomerProfileResultDtoModelBase } from './DeleteCustomerProfileResultDtoModel.base';

/* The TypeScript type of an instance of DeleteCustomerProfileResultDtoModel */
export interface DeleteCustomerProfileResultDtoModelType extends Instance<typeof DeleteCustomerProfileResultDtoModel.Type> {}

/* A graphql query fragment builders for DeleteCustomerProfileResultDtoModel */
export { selectFromDeleteCustomerProfileResultDto, deleteCustomerProfileResultDtoModelPrimitives, DeleteCustomerProfileResultDtoModelSelector } from './DeleteCustomerProfileResultDtoModel.base';

/**
 * DeleteCustomerProfileResultDtoModel
 */
export const DeleteCustomerProfileResultDtoModel = DeleteCustomerProfileResultDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
